/**
 * Converts a hyphenated string to title case.
 * 
 * @param html String to be converted to title case.
 * @returns Converted string in title case.
 */
export const toTitleCase = (str: string): string => {
	const lowercaseWords = new Set(['and', 'or', 'of', 'the', 'a', 'an', 'in', 'on', 'at', 'to', 'for', 'by', 'with', 'from']);

	return str
		.split('-')
		.map((word, index) => {
			const lower = word.toLowerCase();
			if (index > 0 && lowercaseWords.has(lower)) {
				return lower; // keep lowercase if not the first word
			}
			return lower.charAt(0).toUpperCase() + lower.slice(1); // capitalize
		})
		.join(' ');
};